import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subject ,interval} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from '../../../helper/Services/global.service';
import { AppointmentServiceDetails } from '../../../Models/AppointmentAdditionalServiceDetails';
import { AppointmentDocumentDetails, DocumentFiles } from '../../../Models/appointmentservicemodel';
import { OrderStatusService } from '../../../Services/orderstatus/order-status.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { Features } from '../../../../../../Widget/src/app/business-entities/step.class';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { CallDealerLogEntryRequestModel } from '../../../Models/call-dealer-log-entry-requestModel';
import { UploadDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/upload-document/upload-document.component';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { ViewUploadedDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/view-uploaded-document/view-uploaded-document.component';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as saveAs from 'file-saver';
import { environment } from 'projects/StatusTracker/src/environments/environment';

@Component({
  selector: 'app-vehicle-order',
  templateUrl: './vehicle-order.component.html',
  styleUrls: ['./vehicle-order.component.css']
})
export class VehicleOrderComponent implements OnInit, OnDestroy {
  appointmentServiceDetail:AppointmentServiceDetails;
  updateAppointmentServiceDetail:AppointmentServiceDetails;
  currentAppointment: any;
  orderServiceinfo: any;
  orderAdditionalinformation: any;
  orderAdditionalinfo: any;
  isAdditionalInformation = false;
  noRecords=false;
  isAdditionalinfo = false;
  isServiceAvailable = false;
  isHideOrderStatus: boolean = true;
  popupCloseResult = false;
  showData = false;
  buttonJobIds: number;
  repairStatusId:number;
  appointmentDocuments:AppointmentDocumentDetails[]=[]
  Documents:DocumentFiles[]=[]
  approveAllOrder:boolean=false;
  features: Features[] = [];
  EnableCookieConsent:boolean = false;
  private Unsub$ = new Subject<void>();
  @Input() OrderStatusDetail:any;
  currentLanguage:string = "";
  dealerPhone:string = '';
  customerUploadedDocument:boolean=false;
  viewDemandDocument:any = {};
  statusTrackerInterval: number = +EnvSetting.StatusTrackerInterval;
  constructor(
    private gService: GlobalService,
    private orderService: OrderStatusService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cookieService: CookieService,
    private currentLng: CurrentLanguage,
    private commonService:CommonService
  ) { 
    this.currentAppointment = this.gService.getAppInitialData;
  }

  ngOnInit(): void {
    this.orderService.orderDetails?.subscribe((res) => {
      this.dealerPhone = res?.landlineNumber;
    })
    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.EnableCookieConsent = response?.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive;
        if(this.EnableCookieConsent){
          let node = document.createElement('script'); 
          node.src = EnvSetting.Tracker_CookieScript_Key; 
          node.type = 'text/javascript'; 
          document.getElementsByTagName('head')[0].appendChild(node);
         }
         this.customerUploadedDocument = response.find(x=>x.featureCode === CommonEnums.FeatureCode.AllowCustomerUploadDoc)?.isActive
      }
    })
     this.orderService.isOrderSpinnerHide.asObservable().pipe(takeUntil(this.Unsub$))
      .subscribe(x => {
        this.isHideOrderStatus = x;
      });
    if (this.currentAppointment) {
      this.GetVehicleOrderDetails();
    }
    interval(this.statusTrackerInterval).subscribe(() => {
      this.getServiceDetail();
    });
    this.orderService.DemandWiseDocumentCountList.subscribe(res =>{
      if(res.length > 0 && this.appointmentServiceDetail.appointmentDemandList.length > 0){
        this.appointmentServiceDetail.appointmentDemandList.forEach(element => {
          element.docCount = res.find(x=>x.demandNo == element.demandNo)?.docCount
        });
      }
    });
  }

  async GetDetails(_AppointmentGuid:string){
    this.spinner.show();
    await this.orderService.GetAppointmentDocumentDetail().then(result => {
      if (result.responseCode == Enums.ErrorCodes.SuccessCode && result.responseObject?.length > 0) {
        this.appointmentDocuments = result.responseObject;
        if(this.appointmentDocuments?.length > 0){
          this.noRecords = (this.appointmentServiceDetail.appointmentDemandList?.length > 0 !== true);
          this.appointmentServiceDetail.appointmentDemandList.forEach(demand => {
            this.appointmentDocuments.forEach(element => {
              if(demand.id === element.id && element.demandFiles && element.demandFiles.length > 0){
                demand.documnets = element.demandFiles;
              }
            });
          });
        }
        else{
          this.noRecords = true;
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    })
  }

  ViewDocument(Service){
    if(Service?.docCount > 0){
       this.viewDemandDocument.demandNo = Service?.demandNo;
       this.viewDemandDocument.demandName = Service?.customerRequirement;
       this.viewDemandDocument.demandId = Service?.id;
      const modalref = this.modalService.open(ViewUploadedDocumentComponent, { size: 'lg' , windowClass: 'pop-wid1200 pop-hig95vh pop-mh80' });
      modalref.componentInstance.viewDemandDocument = this.viewDemandDocument;
      modalref.componentInstance.requestApplication = Enums.Application.StatusTracker;
      modalref.componentInstance.apiBaseUrl = `${EnvSetting.STATUS_TRACKER_BASE_API_URL}Document`;
      modalref.result.then((response) => {
        if(response.success){ 
              this.getServiceDetail();
              this.spinner.hide();  
        } 
      }, _error => { 
       this.spinner.hide()
      });
     }
 else{
   let msg = this.translate.instant("lblNoDocumentUploaded")
   this.toaster.error(msg);
 }
  }

  ApproveAllDemand(content){
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then((_result) => {
      //modal result
     }, (reason) => {
    this.popupCloseResult = this.getDismissReason(reason);
    if (this.popupCloseResult) {
      this.isPopupCloseResult();
    }
    });
  }

  isPopupCloseResult(){
    if(this.appointmentServiceDetail.appointmentDemandList && this.appointmentServiceDetail.appointmentDemandList.length > 0)
    {
      this.spinner.show();
     let DemandsForApprove =  this.appointmentServiceDetail.appointmentDemandList.filter(x=>x.customerReply === 'Pending' && x.sentForCustomerApproval === true);
     if(DemandsForApprove && DemandsForApprove.length > 0){
      let Demand = DemandsForApprove.map(x => x.id);
      let viewModel={
        demands:Demand,
        isApproved:true,
        currentLanguage: (this.currentLanguage)?this.currentLanguage:EnvSetting.LANGUAGE_CONFIG.defaultLanguage
      }
      this.orderService.ApproveAllDemand(viewModel).subscribe(res => {
        if (res) {
          let msg = this.translate.instant('lblApproved')
          this.toaster.success(msg)
          this.GetVehicleOrderDetails();
        }
      },
      (_err)=>{
        this.spinner.hide();
      },
      ()=>{
        this.spinner.hide();
      });
     }
    }
  }

  GetVehicleOrderDetails() {
    this.spinner.show();
    this.orderService.getOrderStatusDetails().then(res => {
       if (res) {
        this.orderService.repairActualStatusId.next(res.repairStatusDetails.repairStatusId)
        this.orderService.isStatusSpinnerHide.next(true);
        if(res.repairStatusDetails.repairStatusId===Enums.WOStatus.OnHold)
        {
          this.orderService.previousStatusId.next(res.repairStatusDetails.previousRepairStatusId)
        }
        this.getServiceDetail();
        this.isHideOrderStatus = false;
        if (res.servicePlan.length > 0) {
          this.isServiceAvailable = true;
        }
         this.orderServiceinfo = res.servicePlan.filter(x=>x!==null);
        if (res.additionalInformation !== '') {
          this.orderAdditionalinformation = res.additionalInformation;
          this.isAdditionalInformation = false;
        } else {
          this.isAdditionalInformation = true;
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }


  getServiceDetail()
  {
    this.spinner.show();
    const languageCode = (this.cookieService.get('userSelectedLanguage'))?this.cookieService.get('userSelectedLanguage'):EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
    this.orderService.GetServiceDetail(languageCode).then(data => {
      if (data.responseObject.errorCount > 0) {
        this.appointmentServiceDetail = {
          totalPrice: 0,
          totalTime: 0,
          totalInvoicePrice: 0,
          appointmentDemandList: [],
          appointmentJobDetailList: [],
          appointmentJobList: [],
          appointmentPriceDetails:[]
        }
      }
      else {
        this.appointmentServiceDetail = data.responseObject;
        this.GetDetails(this.currentAppointment.AppointmentGuid);
        if(this.appointmentServiceDetail?.appointmentDemandList?.length > 0){
          this.appointmentDemandList();
        }
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }

  appointmentDemandList(){
    this.appointmentServiceDetail.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList.filter(
      x=> x.isAdditionallyAdded===false
    )
    this.appointmentServiceDetail.appointmentDemandList.forEach(x=>{
      if(!x.customerRequirement){
        x.customerRequirement = x.shortDescription;
      }
    })
    this.orderService.repairActualStatusId.subscribe(resStatusId => {
        this.repairStatusId = resStatusId;
      });
     let DemandsForApprove =  this.appointmentServiceDetail.appointmentDemandList.filter(x=>x.customerReply === 'Pending' && x.sentForCustomerApproval === true);
     if(DemandsForApprove?.length > 0 && (this.repairStatusId!== Enums.WOStatus.Invoiceready && this.repairStatusId!==Enums.WOStatus.InvoicePaid && this.repairStatusId!==Enums.WOStatus.Closed)){
       this.approveAllOrder = true;
     }
     else{
       this.approveAllOrder = false;
     }
  }

  ShowButtons(Service:any)
  {
    this.showData = true;
    this.buttonJobIds = Service.id;
  }

  CallDealerLogEntry(){
    let request:CallDealerLogEntryRequestModel ={
      dealerPhone:this.dealerPhone,
    }
    this.orderService.callDealerLogEntry(request).subscribe();
  }

  onApprove(content,Service:any)
  {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then((_result) => { 
      //modal result
    }, (reason) => {
    this.popupCloseResult = this.getDismissReason(reason);
    if (this.popupCloseResult) {
      this.spinner.show();
      const viewModel={
        appointmentDemandId:Service.id,
        demand:Service.customerRequirement,
        isApproved:true,
        currentLanguage: (this.currentLanguage)?this.currentLanguage:EnvSetting.LANGUAGE_CONFIG.defaultLanguage
      }
      this.updateCustomerOrder(viewModel);
    }
    });
  }

  onReject(content,Service:any)
  {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then((_result) => { 
      //modal result
    }, (reason) => {
    this.popupCloseResult = this.getDismissReason(reason);
    if (this.popupCloseResult) {
      this.spinner.show();
      const viewModel={
         appointmentDemandId:Service.id,
         demand:Service.customerRequirement,
         isApproved:false,
         currentLanguage: (this.currentLanguage)?this.currentLanguage:EnvSetting.LANGUAGE_CONFIG.defaultLanguage
      }
      this.updateCustomerOrder(viewModel);
    }
    });
  }
  private updateCustomerOrder(viewModel){
    this.orderService.updateCustomerOrder(viewModel).subscribe(res => {
      if (res) {
        this.GetVehicleOrderDetails();
      }
    },
    (_err)=>{
      this.spinner.hide();
    },
    ()=>{
      this.spinner.hide();
    });
  }

  ngOnDestroy() {
    this.Unsub$.next();
    this.Unsub$.complete();
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  //#region upload demand wise documents

  OpenModel(demand){
    const modalref = this.modalService.open(UploadDocumentComponent, { size: 'lg' , windowClass: 'pop-wid1200 pop-hig95vh pop-mh80'});
    modalref.componentInstance.uniqueId = demand?.id;
    modalref.result.then((response) => {
      if(response.success){
        const doc = this.commonService.getDocument(demand?.id);
        this.spinner.show();
        this.orderService.UploadCustomerDocument(doc).subscribe((response) => {
            this.spinner.hide();     
            if(response){
              this.getServiceDetail();
               let msg = this.translate.instant("lblDocumentUploadedSuccessfully")
               this.toaster.success(msg);
               this.commonService.removeDocument(demand?.id);
             }
        }, _error => {
          this.spinner.hide()
        });
      }
    }, _error => { 
     this.spinner.hide();
    });
  }
  async downloadFile(path: string) {
    this.spinner.show();
    await this.orderService.DownloadFile(path).then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          const file = res.responseObject;
          const blob = Utility.base64toBlob(file.fileContents, file.contentType);
          saveAs(blob, file.fileDownloadName);
        }
      }).finally(() => {
        this.spinner.hide();
      });
  }
  //#endregion
}
